import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';
import { CLessonInCourse, LESSONS_TYPES } from '@yandex-int/k-common/typings';

import {
    SPEC_COURSE_LESSON_VIEW_DEFAULT_TAB,
    SPEC_COURSE_LESSON_VIEW_TABS,
} from 'common.components/spec-course-lesson-view/typings';

import { SpecCourseStore } from './typings';

const initialState: SpecCourseStore = {
    clessons: [],
    lessonsLoadingStatus: LOADING_STATUSES.UNSENT,
    initStatus: LOADING_STATUSES.UNSENT,
    tab: SPEC_COURSE_LESSON_VIEW_DEFAULT_TAB,
};

// Параметры нужны для саги
/* eslint-disable @typescript-eslint/no-unused-vars */
const slice = createSlice({
    name: 'SPEC_COURSE_LESSONS',
    initialState: initialState,
    reducers: {
        closeModal: () => initialState,

        clearLessons: (state) => {
            state.clessons = [];
        },

        setLessons: (state, action: PayloadAction<{ clessons: Array<CLessonInCourse> }>) => {
            const { clessons } = action.payload;

            state.clessons = clessons;
        },

        getLessons: (
            state,
            action: PayloadAction<{
                courseId: number;
                types: Array<LESSONS_TYPES>;
                prevClessons?: Array<CLessonInCourse>;
            }>
        ) => {
            state.lessonsLoadingStatus = LOADING_STATUSES.LOADING;
        },

        getLessonsSuccess: (state, action: PayloadAction<{ courseId: number }>) => {
            state.lessonsLoadingStatus = LOADING_STATUSES.SUCCESS;
        },

        getLessonsError: (state, action: PayloadAction<{ courseId: number }>) => {
            state.lessonsLoadingStatus = LOADING_STATUSES.ERROR;
        },

        addSpecCourses: (
            state,
            action: PayloadAction<{
                teamId: number;
                onSuccess: (teamId: number, specCourseId: number) => void;
            }>
        ) => {
            //saga only
        },

        initCourses: (
            state,
            action: PayloadAction<{
                teamId: number;
                onSuccess: (teamId: number, specCourseId: number) => void;
                shouldNotTryAddSpecCourse?: boolean;
            }>
        ) => {
            state.initStatus = LOADING_STATUSES.LOADING;
        },

        initCoursesSuccess: (state) => {
            state.initStatus = LOADING_STATUSES.SUCCESS;
        },

        initCoursesError: (state) => {
            state.initStatus = LOADING_STATUSES.ERROR;
        },
        setTab: (state, action: PayloadAction<{ tab: SPEC_COURSE_LESSON_VIEW_TABS }>) => {
            state.tab = action.payload.tab;
        },

        makeFormSubmitted: () => {
            // saga
        },
    },
});

export const specCourseActions = slice.actions;
export const specCourseReducer = slice.reducer;
